/**
 * Validate phone "(99) 9999-9999" or "(99) 99999-9999"
 * TODO: Add unit test
 *
 * @param string
 * @returns true | string (error)
 */
export const validatePhone = (string: string): string | true => {
  if (string.length !== 14 && string.length !== 15) {
    return 'Telefone inválido.';
  }

  const number = string.replace(/[^\d]/g, '');
  if (number.length !== 10 && number.length !== 11) {
    return 'Telefone inválido.';
  }

  return true;
}

/**
 * Validate documents (CPF and CNPJ)
 * TODO: Add unit test
 *
 * @param string
 * @returns true | string (error)
 */
export const validateDocument = (string: string): string | true => {
  const value = (string || '').replace(/[^\w]/g, '').toUpperCase();

  if (value.length === 11 && validateCpf(string) === true) {
    return true;
  }

  if (value.length === 14 && validateCnpj(string) === true) {
    return true;
  }

  return 'Documento inválido.';
}

/**
 * Validate CPF
 * TODO: Add unit test
 *
 * @param string
 * @returns true | string (error)
 */
export const validateCpf = (string: string): string | true => {
  const value = (string || '').replace(/[^\d]/g, '');

  if (value.length !== 11) {
    return 'CPF inválido.';
  }

  const checkDigit = (factor: number) => {
    let total = 0;
    for (let i = 0; i < factor - 1; i++) {
      total += parseInt(value[i]) * (factor - i);
    }

    const remainder = (total * 10) % 11;
    return remainder === 10 ? 0 : remainder;
  };

  const digit1 = checkDigit(10);
  const digit2 = checkDigit(11);

  if (digit1 === parseInt(value[9]) && digit2 === parseInt(value[10])) {
    return true;
  }

  return 'CPF inválido.';
}

/**
 * Validate CNPJ (new format too)
 * TODO: Add unit test
 *
 * @param string
 * @returns true | string (error)
 */
export const validateCnpj = (string: string): string | true => {
  const value = (string || '').replace(/[^\w]/g, '').toUpperCase();

  if (value.length !== 14) {
    return 'CNPJ inválido.';
  }

  const getCharValue = (char: string): number => {
    const code = char.charCodeAt(0);
    return code - 48;
  };

  const checkDigit = (input: string, weights: number[]): number => {
    let total = 0;

    for (let i = 0; i < weights.length; i++) {
      const val = getCharValue(input[i]);
      if (isNaN(val) || val < 0) return -1;
      total += val * weights[i];
    }

    const remainder = total % 11;
    return remainder < 2 ? 0 : 11 - remainder;
  };

  const weights1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const weights2 = [6, ...weights1];

  const base = value.slice(0, 12);
  const digit1 = checkDigit(base, weights1);
  const digit2 = checkDigit(base + digit1, weights2);

  if (digit1 === parseInt(value[12]) && digit2 === parseInt(value[13])) {
    return true;
  }

  return 'CNPJ inválido.';
};

export {};
